<footer id="footer" class="text-center d-flex align-items-center justify-content-center mb-2 mt-0" style="min-height: 45px; max-height: 45px;">
    <div class="container text-center">
        <img src="../../../../assets/img/footer_planok.svg" alt="logo-planok">
    </div>
  </footer>
